import React from 'react';
import { IntlProvider } from 'react-intl';
import { useAppContext } from "../context/AppContext";
import PayuLogo from "./components/PayuLogo";
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import TransactionInfoRouterView from "../pages/TransactionInfoRouterView";
import dictionary from "../../translations/dictionary";
import TransactionSearcherRouterView from "../form/TransactionSearcherRouterView";
import Footer from "./components/Footer";

function App() {
  const { language } = useAppContext();

  return (
      <IntlProvider
          onWarn={() => {
              /* do nothing */
          }}
          locale={language}
          messages={dictionary[language]}
          defaultRichTextElements={{
              strong: (chunks) => <strong>{chunks}</strong>,
              p: (chunks) => <p>{chunks}</p>,
          }}
      >

      <div className="app">
          <HashRouter>
              <header>
                  <PayuLogo/>
              </header>
              <Routes>
                  <Route path="/status" element={<TransactionInfoRouterView />} />
                  <Route path="*" element={<Navigate to="/" />} />
                  <Route index element={<TransactionSearcherRouterView />} />
              </Routes>
          <footer>
                <Footer/>
          </footer>
          </HashRouter>
      </div>
    </IntlProvider>
  );
}


export default App;
